"use strict";

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.trim");

var reduce = require("./reduce.js");

var go1 = require("./go1.js");

var mapL = require("../Lazy/mapL.js");

module.exports = html;

function html(strs, ...datas) {
  datas = mapL(d => d === undefined ? '' : d, datas);
  return go1(reduce((res, str) => go1(datas.next().value, data => `${res}${data}${str}`), strs), a => a.replace(/\s*(\>|\<)\s*/g, '$1').trim());
}